export class Fonts {
  static primary = `'Work Sans', sans-serif`;
  // static secondary = 'Poppins-Bold';
  // static tertiary = 'Poppins-Medium';
}
